import React, { useEffect, useState } from 'react';
import { Loader2, TrendingUp, TrendingDown, Users } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { fmtDate } from '../../lib/dates';

const FALLO = { acoge: 'Acoge', rechaza: 'Rechaza', acoge_parcialmente: 'Acoge parcialmente' };
const STATUS = { running: 'En curso', ready_for_verdict: 'Lista para sentencia', finished: 'Terminada' };

const Trend = ({ items }) => {
  const done = items.filter((i) => i.avg_score != null).slice().reverse();
  if (done.length < 2) return null;
  const delta = Math.round((done[done.length - 1].avg_score - done[0].avg_score) * 10) / 10;
  const Icon = delta >= 0 ? TrendingUp : TrendingDown;
  return (
    <div data-testid="trial-history-trend" className="rounded-xl border border-slate-800 bg-slate-900/70 p-3">
      <p className={`flex items-center gap-2 text-sm font-semibold ${delta >= 0 ? 'text-emerald-300' : 'text-red-300'}`}><Icon className="h-4 w-4" />{delta >= 0 ? '+' : ''}{delta} puntos desde tu primera simulación</p>
      <div className="mt-3 flex h-16 items-end gap-1.5">
        {done.map((i) => <div key={i.id} title={`${fmtDate(i.created_at)} · ${i.avg_score}/10`} className="flex-1 rounded-t bg-amber-500/70" style={{ height: `${Math.max(6, i.avg_score * 10)}%` }} />)}
      </div>
    </div>
  );
};

// Past simulations of a case with average score and simulated outcome
export const TrialHistory = ({ matterId, onOpen, currentId }) => {
  const { api } = useAuth();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get(`/trial-sim/matters/${matterId}/history`).then((r) => setItems(r.data.items)).catch(() => setItems([])); }, [matterId, currentId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!items) return <Loader2 className="h-5 w-5 animate-spin text-slate-500" />;
  if (!items.length) return <p data-testid="trial-history-empty" className="text-sm text-slate-500">Aún no hay simulaciones de este caso.</p>;
  return (
    <div data-testid="trial-history" className="space-y-3">
      <Trend items={items} />
      {items.map((i, n) => (
        <button key={i.id} data-testid={`trial-history-item-${n}`} onClick={() => onOpen(i.id)}
          className={`w-full rounded-lg border p-3 text-left transition-colors ${i.id === currentId ? 'border-amber-500 bg-amber-500/10' : 'border-slate-800 hover:border-slate-600'}`}>
          <div className="flex items-center gap-2 text-xs">
            <span className="font-semibold text-white">#{items.length - n} · {fmtDate(i.created_at)}</span>
            <span className="text-slate-400">{STATUS[i.status]} · {i.stages_done}/{i.stages_total} etapas</span>
            {i.team_size > 0 && <span className="flex items-center gap-1 text-sky-300"><Users className="h-3 w-3" />{i.team_size + 1}</span>}
            <span className="ml-auto text-amber-300">{i.avg_score != null ? `${i.avg_score}/10` : '—'}</span>
          </div>
          {i.fallo && <p className="mt-1 text-xs text-slate-300">Sentencia: {FALLO[i.fallo] || i.fallo} · Prob. de victoria {i.probabilidad_victoria}%</p>}
        </button>
      ))}
    </div>
  );
};
